import { IPagination, IPaginationDTO } from '@/models/pagination.model';
import { IAdminProfileResponse, Roles } from '@/models/admins.model';

export enum UsersEndpoints {
  ADMINS_LIST = '/admins',
  USERS_LIST = '/users',
  PARTNERS_LIST = '/partners',
}

export interface IUserProfile {
  id?: string;
  full_name?: string;
  phone?: string;
  orders_count?: number;
  active?: string;
  created_at?: string;
}

// ----------------- DTOs ----------------

export interface IGetAdminsListDTO extends Partial<IPaginationDTO> {
  name?: string;
  email?: string;
  active?: '0' | '1';
  roles?: Roles[];
  limit?: number;
  hidden?: '0' | '1';
  phone?: string;
  verified_at?: string;
  created_at?: string;
  date_from?: string;
  date_to?: string;
  title?: string;
  region?: string;
}

export interface IGetUsersListDTO extends Partial<IPaginationDTO> {
  id?: string;
  full_name?: string;
  phone?: string;
  active?: '0' | '1';
  limit?: number;
  created_at?: string;
}

export interface IAdminDetailsDTO {
  id?: string;
  last_name: string;
  email: string;
  first_name: string;
  region_id?: string | null;
}

// ------------ Responses --------------

export interface IAdminsListResponse {
  data: IAdminProfileResponse[];
  meta: IPagination;
}

export interface IUsersListResponse {
  data: IUserProfile[];
  meta: IPagination;
}

export interface IUserAuthData {
  data: {
    access_token: string;
  };
}
